<section class="c-cover c-cover--basic t-alert-danger" id="inicio">

  <div class="c-cover__image"></div>

  <h1 class="c-cover__main-title omega">
    Contato
  </h1>

  <div class="c-cover__content">

    <red-contact-form
      class="c-contact__form"
      [hasSchool]="true">
    </red-contact-form>

  </div>

</section>
